import React, { useEffect, useMemo, useState } from 'react';

import { Calendar, DateObject } from 'react-multi-date-picker';
import { ButtonClassic } from '@/components/buttons/ButtonClassic';
import { Counter } from '@/components/counter/Counter';
import { Pill } from '@/components/filters/Pill';
import { CloseIcon } from '@/components/icons';
import { Modal } from '@/components/modal';

import { findAvailableTours } from '@/actions/find-available-tours';
import { fetchAvailability } from '@/actions/fetch-availability';
import { months as allMonths } from '@/config/constants';
import CalendarPlaceholder from './CalendarPlaceholder';
import { YearPicker } from './YearPicker';
import { TMonth } from '@/types';
import './calendar.css';
import { TAvailability, TAvailableMonths, useReservation } from './hooks/useReservation';
import { Visitors } from './Visitors';
import { YearMonthPicker } from './MonthPicker';

const weekDays = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

const today = new Date();

interface IAvailabilityCalendarProps {
  selectedMonth: number | null;
  availability: TAvailability;
  year: number;
  reservation: {
    calendarValue: DateObject | null;
    handleChangeCalendarValue: (value: DateObject) => void;
  };
}

export const AvailabilityCalendar = ({
  selectedMonth,
  availability,
  year,
  reservation,
}: IAvailabilityCalendarProps) => (
  <div className="w-full">
    <div className="flex grow flex-col h-full justify-between items-start">
      <h3 className="text-md font-semibold cursor-default">Select a date</h3>
      {selectedMonth && availability[year][selectedMonth] ? (
        <Calendar
          hideMonth
          hideYear
          value={reservation.calendarValue}
          onChange={reservation.handleChangeCalendarValue}
          buttons={false}
          weekDays={weekDays}
          minDate={today}
          shadow={false}
          mapDays={(props) => {
            const zeroIndexed = props.date.day - 1;
            const isAvailable = availability[year][selectedMonth][zeroIndexed];
            if (!isAvailable) {
              return {
                disabled: true,
              };
            }
          }}
          className="calendar-dark"
        />
      ) : (
        <CalendarPlaceholder />
      )}
    </div>
  </div>
);
